import { call, fork, put, take } from 'redux-saga/effects';
import {Api} from '../api';
import {LocationBookingStats} from '../api/types';
import {FetchLocationBookingStatsPayload, fetchLocationBookingStats} from '../action/locationsCommands';
import {locationBookingStatsFetched} from '../action/locationsEvents';
import Logger from '../common/logger';
import {Action} from 'redux-actions';
import moment from 'moment';
import {enqueueErrorSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';

export const onFetchLocationBookingStats = function*(locationId: number) {
    try {
        const locationBookingStats: LocationBookingStats = yield call(
            Api.getLocationBookingStats,
            locationId,
            moment().subtract(7, 'days').toDate(),
        );

        yield put(locationBookingStatsFetched({ locationId, locationBookingStats }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({ message: getI18n().t('snackbar.error.fetch_location_booking_stats') }));
    }
};

export function* fetchLocationBookingStatsFlow() {
    while (true) {
        const action: Action<FetchLocationBookingStatsPayload> = yield take(fetchLocationBookingStats.toString());
        yield fork(onFetchLocationBookingStats, action.payload.locationId);
    }
}
